import Vue from 'vue'
export let urlParam = {}
export const query_to_url = (object = {}, encode = false) => {
  const list = []
  for (const key in object) {
    if (Object.hasOwnProperty.call(object, key)) {
      const element = object[key]
      if (element != undefined) {
        list.push(`${key}=${encode ? encodeURIComponent(element) : element}`)
      }
    }
  }
  const str = list.join('&')
  return str
}

/*******
 * @description:
 * @param {*} link -
 * @param {*} decode - true  是否解析 //!!! 一进来就解析会漏字符，后面再解析一次
 * @return {*}
 */
export const url_to_query = (link = '', decode = false) => {
  console.error('🚀 ~ file: getUrlParam.js:24 ~ url_to_query 运行: ')
  // window.location.href 获取地址
  // let url = "https://xxxx.com/xxx/demo?type=1&id=2";
  let url = ''
  // setTimeout(() => {
  url = link || window.location.href
  // }, 0);

  const p = url.split('?')[1]
  if (!p) return null
  const keyValue = p.split('&')
  const obj = {}
  for (let i = 0; i < keyValue.length; i++) {
    const item = keyValue[i].split('=')
    const key = item[0]
    const value = item[1]
    try {
      obj[key] = decode ? decodeURIComponent(value) : value;
    } catch (error) {
      console.error('路径参数编解码错误 Error decoding value:', error);
    }
    // obj[key] = value;
  }
  // console.log("url_to_query keyValue:", keyValue); //  ['type=1','id=2']
  // console.log("url_to_query obj:", obj); //  {type:'1',id:'2'}
  //! !! 如果是 window.location.href 则覆盖urlParam，因为第一次可能会解析不对
  if (!link) {
    urlParam = obj || {}
  }

  return obj || null
}


export const url_to_query2 = (link = '', decode = false) => {
  let objStr = '{"follow_state":"1","user_name":"%E7%94%A8%E6%88%B7wgjO","is_new":"0","curr_time":"1711453825877","user_token":"f28cff735e454f5290607d61430835b8","native":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTcxMTQ1Mzk1OSwianRpIjoiNTZiMDQ0OWItNTEzYi00MmNiLWE1ODMtYmFiMDFlNWQzMWJmIiwidHlwZSI6ImFjY2VzcyIsInN1YiI6IjEzMzk4OTg2OTE4fHVzZXIiLCJuYmYiOjE3MTE0NTM5NTksImV4cCI6MTcxMjA1ODc1OX0.lxevrAq2V1d4ZTHfl2nFVdonLvDRE6guMHAFFK9MNl4"}'
  let obj = JSON.parse(objStr)
  console.log('obj',obj)
  return obj || null
}

urlParam = url_to_query() || {}

Vue.prototype.$urlParam = urlParam
Vue.prototype.$_query_to_url = query_to_url
Vue.prototype.$_url_to_query = url_to_query

export default urlParam
